import React from 'react';
import { Layout, Dropdown, Space, Avatar, Button, Drawer } from 'antd';
import { UserOutlined, MenuOutlined, LogoutOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Header } = Layout;

const AppHeader = ({ isMobile, formMeta, userMenuItems, drawerVisible, setDrawerVisible, handleLogout }) => {
  const navigate = useNavigate();
  
  return (
    <>
      <Header
        style={{
          background: '#fff',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingLeft: isMobile ? 16 : 24,
          paddingRight: isMobile ? 16 : 24,
          position: 'sticky',
          top: 0,
          zIndex: 100,
          height: 'auto',
          minHeight: 64
        }}
      >
        <div style={{ 
          fontSize: isMobile ? 16 : 18, 
          fontWeight: 600,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: 1
        }}>
          {formMeta.image?.[0]?.public_url && (
            <img
              src={formMeta.image[0].public_url}
                alt="Form Logo"
                style={{
                  width: 32,
                  height: 32,
                  objectFit: 'cover',
                  borderRadius: 6,
                  marginRight: 12,
                  verticalAlign: 'middle'
                }}
            />
          )}
          {formMeta.name || 'Site Visit Form'}
        </div>

        {!isMobile ? (
          <Dropdown menu={{ items: userMenuItems }} trigger={['click']}>
            <Space style={{ cursor: 'pointer' }}>
              <Avatar
                size="large"
                icon={<UserOutlined />}
                style={{ backgroundColor: '#1976d2' }}
              />
            </Space>
          </Dropdown>
        ) : (
          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={() => setDrawerVisible(true)}
            style={{ marginLeft: 12 }}
          />
        )}
      </Header>

      {isMobile && (
        <Drawer
          title="Menu"
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          placement="right"
        >
          <div style={{ marginBottom: 20 }}>
            <Avatar
              size={64}
              icon={<UserOutlined />}
              style={{ backgroundColor: '#1976d2', marginBottom: 12 }}
            />
          </div>

          <Button
            type="text"
            icon={<UserOutlined />}
            block
            onClick={() => {
              navigate('/');
              setDrawerVisible(false);
            }}
            style={{ textAlign: 'left', marginBottom: 8 }}
          >
            Profile
          </Button>
          <Button
            type="text"
            icon={<LogoutOutlined />}
            block
            danger
            onClick={handleLogout}
            style={{ textAlign: 'left' }}
          >
            Logout
          </Button>
        </Drawer>
      )}
    </>
  );
};

export default AppHeader;